// extracted by mini-css-extract-plugin
export var container = "_52-0";
export var icon = "_52-1";
export var text = "_52-2";